<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <b-row>
      <b-col cols="auto" class="mr-auto">
        <h1 class="mb-3">Reports</h1>
      </b-col>
      <b-col cols="auto">
        <AddReport />
      </b-col>
    </b-row>
    <ReportsTable />
  </b-container>
</template>

<script>
import ReportsTable from "@/components/ReportsTable";
import AddReport from "@/components/AddReport";
import { mapGetters } from "vuex";

export default {
  components: {
    ReportsTable,
    AddReport
  },
  data() {
    return {};
  },
  created() {
    this.$store.commit("setBreadcrumbs", [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" }
      },
      {
        text: "Izveštaji",
        to: { name: "reports" },
        active: true
      }
    ]);
  },
  computed: {
    ...mapGetters({
      breadcrumbs: "breadcrumbs",
      project_title: "project/title"
    })
  }
};
</script>

<style>
</style>